import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import React from 'react';
import { FileForm } from '../FilesPage/components/FileForm';
import { useInjection } from './hook';

export const CreateFilesPage = () => {
  const {
    asyncCreateFile,
    optionClient,
    optionClientChild,
    optionAuctionDeliveryLocation,
    changeOptionClient
  } = useInjection();
  return (
    <LayoutAdminTable>
      <FileForm
        optionClient={optionClient}
        optionClientChild={optionClientChild}
        optionAuctionDeliveryLocation={optionAuctionDeliveryLocation}
        changeOptionClient={changeOptionClient}
        createForm={asyncCreateFile}
      />
    </LayoutAdminTable>
  );
};
